// Manejo de fechas en la zona del negocio: America/Montevideo (UTC-3, sin
// horario de verano desde 2015). Critico porque el Worker corre en UTC: un
// pedido tomado a las 22:30 hora local debe caer en el dia correcto.
//
// Estrategia: desplazamos el instante UTC 3 horas hacia atras para que los
// getters UTC lean la "hora de pared" de Montevideo, y formateamos el dia.

const OFFSET_MIN = -180; // -03:00

function pad(n: number): string {
  return n < 10 ? "0" + n : String(n);
}

function aMontevideo(ahora: Date): Date {
  return new Date(ahora.getTime() + OFFSET_MIN * 60 * 1000);
}

function formatearDia(d: Date): string {
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}`;
}

/** Fecha de hoy (YYYY-MM-DD) segun la hora de Montevideo. */
export function hoyMontevideo(ahora: Date = new Date()): string {
  return formatearDia(aMontevideo(ahora));
}

/** Fecha de manana (YYYY-MM-DD) segun Montevideo: default de fecha_entrega. */
export function mananaMontevideo(ahora: Date = new Date()): string {
  const local = aMontevideo(ahora);
  const manana = new Date(local.getTime() + 24 * 60 * 60 * 1000);
  return formatearDia(manana);
}

/** Valida que un string sea una fecha 'YYYY-MM-DD' plausible. */
export function esFechaValida(s: string): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return false;
  const [a, m, d] = s.split("-").map(Number);
  if (m < 1 || m > 12 || d < 1 || d > 31) return false;
  return a >= 2000 && a <= 2100;
}

/**
 * ¿La fecha quedo atras? Compara contra HOY en Montevideo, no contra el reloj
 * del celular: si el telefono tiene mal la fecha, igual no se puede pedir para
 * un dia que ya paso. Hoy NO es pasado (se puede pedir para el turno tarde).
 *
 * La comparacion es de strings porque 'YYYY-MM-DD' ordena igual que el
 * calendario, y asi no hay Date de por medio ni zona que se cuele.
 */
export function esFechaPasada(fecha: string, ahora: Date = new Date()): boolean {
  return esFechaValida(fecha) && fecha < hoyMontevideo(ahora);
}

/**
 * Rango [desde, hasta] (YYYY-MM-DD) para dia/semana/mes a partir de una fecha
 * de referencia. Semana = lunes a domingo. Usado por filtros de Cuentas e Informes.
 */
export function rangoFechas(
  ref: string,
  tipo: "dia" | "semana" | "mes",
): [string, string] {
  const [a, m, d] = ref.split("-").map(Number);
  const base = new Date(Date.UTC(a, m - 1, d));
  if (tipo === "dia") return [ref, ref];
  if (tipo === "semana") {
    const dow = (base.getUTCDay() + 6) % 7; // lunes=0
    const lunes = new Date(base);
    lunes.setUTCDate(base.getUTCDate() - dow);
    const domingo = new Date(lunes);
    domingo.setUTCDate(lunes.getUTCDate() + 6);
    return [formatearDia(lunes), formatearDia(domingo)];
  }
  const primero = new Date(Date.UTC(a, m - 1, 1));
  const ultimo = new Date(Date.UTC(a, m, 0));
  return [formatearDia(primero), formatearDia(ultimo)];
}
